import React, { useState } from "react";
import { TabNav, Box, Flex, IconButton } from "@radix-ui/themes";
import { HamburgerMenuIcon, Cross1Icon } from "@radix-ui/react-icons";
import { Link, useLocation } from "react-router-dom";
import styles from "./styles.module.scss";
import logo from "../../../assets/logo/white-logo.png";
import Button from "../Button";

const Menu = ({
  items,
  defaultActive,
  actionButton,
  signInButton,
  onNavigate,
}) => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Determine which nav item should be active, matching by path
  const getActiveHref = () => {
    if (!location || !location.pathname) return defaultActive || items[0]?.href;
    // Basic logic for matching / and e.g. /about, /services
    if (location.pathname === "/" || location.pathname === "") return "/";
    const found = items.find(
      (it) => it.href !== "/" && location.pathname.startsWith(it.href)
    );
    return found ? found.href : defaultActive || items[0]?.href;
  };
  const activeHref = getActiveHref();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <Box className={styles["menu"]}>
      <Flex align="center" justify="between">
        <Link to="/">
          <img src={logo} alt="Renova Logo" className={styles["menu-logo"]} />
        </Link>

        {/* Desktop Menu */}
        <Flex align="center" gap="4" className={styles["menu-desktop"]}>
          <TabNav.Root>
            {items.map((item, index) => (
              <TabNav.Link
                key={index}
                href={item.href}
                active={activeHref === item.href}
                onClick={(e) => {
                  e.preventDefault();
                  onNavigate && onNavigate(item.href);
                }}
              >
                {item.label}
              </TabNav.Link>
            ))}
          </TabNav.Root>

          {actionButton && (
            <Button
              className={styles["menu-action-button"]}
              size="3"
              variant={actionButton.variant || "normal"}
              onClick={actionButton.onClick}
              backgroundColor={
                actionButton.backgroundColor || "var(--color-secondary)"
              }
              textColor={actionButton.textColor || "var(--color-primary)"}
            >
              {actionButton.label}
            </Button>
          )}
          {signInButton && (
            <Button
              className={styles["menu-secondary-button"]}
              size="3"
              variant={signInButton.variant || "outlined"}
              onClick={signInButton.onClick}
              backgroundColor={
                signInButton.backgroundColor || "var(--color-primary)"
              }
              textColor={signInButton.textColor || "var(--color-secondary)"}
            >
              {signInButton.label || "Sign In"}
            </Button>
          )}
        </Flex>

        {/* Mobile Burger Icon */}
        <IconButton
          className={styles["menu-burger"]}
          onClick={toggleMobileMenu}
          variant="ghost"
        >
          {isMobileMenuOpen ? (
            <Cross1Icon width="24" height="24" />
          ) : (
            <HamburgerMenuIcon width="24" height="24" />
          )}
        </IconButton>
      </Flex>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <Box className={styles["menu-mobile"]}>
          <Flex direction="column" gap="3">
            {items.map((item, index) => (
              <a
                key={index}
                href={item.href}
                className={`${styles["menu-mobile-link"]} ${
                  activeHref === item.href ? styles["active"] : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  onNavigate && onNavigate(item.href);
                  setIsMobileMenuOpen(false);
                }}
              >
                {item.label}
              </a>
            ))}
            {signInButton && (
              <Button
                className={styles["menu-secondary-button"]}
                size="3"
                variant={signInButton.variant || "outlined"}
                onClick={() => {
                  signInButton.onClick && signInButton.onClick();
                  setIsMobileMenuOpen(false);
                }}
                backgroundColor={
                  signInButton.backgroundColor || "var(--color-primary)"
                }
                textColor={signInButton.textColor || "var(--color-secondary)"}
              >
                {signInButton.label || "Sign In"}
              </Button>
            )}
            {actionButton && (
              <Button
                className={styles["menu-action-button"]}
                size="3"
                variant={actionButton.variant || "normal"}
                onClick={() => {
                  actionButton.onClick();
                  setIsMobileMenuOpen(false);
                }}
                backgroundColor={
                  actionButton.backgroundColor || "var(--color-secondary)"
                }
                textColor={actionButton.textColor || "var(--color-primary)"}
              >
                {actionButton.label}
              </Button>
            )}
          </Flex>
        </Box>
      )}
    </Box>
  );
};

export default Menu;
